import React from 'react';
import { Alert } from '@mui/material';
import useOnboarding from '../../hooks/useOnboarding';

const OnboardingTip = ({ tipId, children, severity = 'info', sx = {} }) => {
  const { isTipSeen, markTipSeen } = useOnboarding();

  if (!tipId || isTipSeen(tipId)) {
    return null;
  }

  return (
    <Alert
      severity={severity}
      onClose={() => markTipSeen(tipId)}
      sx={{ mb: 2, textAlign: 'left', ...sx }}
    >
      {children}
    </Alert>
  );
};

export default OnboardingTip;
